import { render, staticRenderFns } from "./eventsVideo.vue?vue&type=template&id=2aab9c46&"
import script from "./eventsVideo.vue?vue&type=script&lang=js&"
export * from "./eventsVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/eventsVideo.vue
// module id = 1336
// module chunks = 0